import vendorSearch from './scripts/vendor-search'
import searchSlide from './scripts/search-slide'
import { searchLogoSlider } from './scripts/logo-slider'

vendorSearch()
searchSlide()
searchLogoSlider()